import { ref, resolveDirective, withDirectives, createElementBlock, openBlock, createVNode, unref, withCtx, createElementVNode, normalizeClass, createBlock } from "vue";
import _sfc_main$1 from "./option_bar_member_group.vue.js";
import { OPTIONS_UPDATE_EVENT } from "../../lib/constants.js";
import { getControlByMemberType, getControlByValue } from "../../lib/control.js";
import { DtStack, DtButton } from "@dialpad/dialtone-vue";
import DtIconMinimize from "@dialpad/dialtone-icons/vue3/minimize";
import DtIconExpand from "@dialpad/dialtone-icons/vue3/expand";
const _hoisted_1 = { class: "dialtone-playground__controls" };
const __default__ = {
  name: "DtcOptionBar"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    /**
     * Component to render.
     */
    component: {
      type: Object,
      required: true
    },
    /**
     * Options data object.
     */
    options: {
      type: Object,
      required: true
    },
    /**
     * Info data object.
     */
    info: {
      type: Object,
      required: true
    }
  },
  emits: [OPTIONS_UPDATE_EVENT, "toggle-full-screen"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const isFullscreen = ref(false);
    const toggleFullScreen = () => {
      isFullscreen.value = !isFullscreen.value;
      emit("toggle-full-screen", isFullscreen.value);
    };
    function getBindingControls(binding, value, ...controls) {
      var _a;
      const validControls = [
        ...((_a = binding.types) == null ? void 0 : _a.map((type) => getControlByMemberType(type, binding))) ?? [],
        ...controls
      ];
      return [
        validControls,
        validControls.find((control) => control === getControlByValue(value)) ?? validControls[0]
      ];
    }
    function getSlotControls() {
      return getStaticControl("slot");
    }
    function getStaticControl(control) {
      return [
        [control],
        control
      ];
    }
    function updateMember(memberGroup, { member, value }) {
      emit(OPTIONS_UPDATE_EVENT, (options) => {
        options[memberGroup][member] = value;
      });
    }
    function updateSlots(e) {
      updateMember("slots", e);
    }
    function updateProps(e) {
      updateMember("props", e);
    }
    return (_ctx, _cache) => {
      const _directive_dt_tooltip = resolveDirective("dt-tooltip");
      const _directive_dt_scrollbar = resolveDirective("dt-scrollbar");
      return withDirectives((openBlock(), createElementBlock("section", _hoisted_1, [
        createVNode(unref(DtStack), { gap: "500" }, {
          default: withCtx(() => [
            createVNode(unref(DtStack), {
              gap: "500",
              direction: "row",
              class: "d-mtn8 d-mbn8 d-mrn4 d-d-none md:d-d-flex"
            }, {
              default: withCtx(() => [
                createElementVNode("h2", {
                  class: normalizeClass(["d-fl1", isFullscreen.value ? "d-headline--lg" : "d-headline--md"])
                }, " Button ", 2),
                withDirectives((openBlock(), createBlock(unref(DtButton), {
                  kind: "muted",
                  importance: "clear",
                  size: "sm",
                  onClick: toggleFullScreen
                }, {
                  icon: withCtx(({ iconSize }) => [
                    isFullscreen.value ? (openBlock(), createBlock(unref(DtIconMinimize), {
                      key: 0,
                      size: iconSize
                    }, null, 8, ["size"])) : (openBlock(), createBlock(unref(DtIconExpand), {
                      key: 1,
                      size: iconSize
                    }, null, 8, ["size"]))
                  ]),
                  _: 1
                })), [
                  [_directive_dt_tooltip, `Fullscreen`]
                ])
              ]),
              _: 1
            }),
            createVNode(unref(DtStack), { gap: "500" }, {
              default: withCtx(() => [
                createVNode(_sfc_main$1, {
                  component: __props.component,
                  "control-selector": getSlotControls,
                  members: __props.info.slots,
                  values: __props.options.slots,
                  "onUpdate:member": updateSlots
                }, null, 8, ["component", "members", "values"]),
                createVNode(_sfc_main$1, {
                  component: __props.component,
                  "control-selector": (prop, value) => getBindingControls(prop, value, "null"),
                  members: __props.info.props,
                  values: __props.options.props,
                  "onUpdate:member": updateProps
                }, null, 8, ["component", "control-selector", "members", "values"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])), [
        [_directive_dt_scrollbar]
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=option_bar.vue.js.map
